// extracted by mini-css-extract-plugin
module.exports = {"link":"basket-link--13291"};